/** Shared react-query cache windows for the Unified Communications feature. */
export const UC_CACHE_TIME = {
  SHORT_MS: 15 * 1000,
  MEDIUM_MS: 30 * 1000,
  LONG_MS: 60 * 1000,
  FIVE_MINUTES_MS: 5 * 60 * 1000,
};

/** Debounce applied to search inputs before hitting the list APIs. */
export const UC_SEARCH_DEBOUNCE_MS = 300;
